module.exports = __webpack_public_path__ + "static/media/instagram.b41cd101.svg";